<template>
  <main>
    <img :src="isSelected?require('./images/circle_01@2x.png'):require('./images/circle_02@2x.png')" class="select" @click="changeSelected" v-if="showSelect"/>
    <div class="content" @click="goDetail">
      <div class="activeType" v-if="activeType"><span>{{activeType}}</span></div>
      <div class="data">
        <div class="data-type">
          <span class="data-type-value">{{couponType}}</span>
          <img src="./images/icon_info@2x.png" class="data-type-img" @click="showInfo" v-if="showInfoBool"/>
        </div>
        <div class="data-money" :class="color">{{money}}<span class="data-unit" :class="fontColor">{{unit}}</span></div>
      </div>
      <div class="item-bottom">
        <div class="endTime" v-if="endTime">{{endTime}}</div>
        <div class="endTime" v-if="useType">{{useType}}</div>
      </div>
    </div>
    <nd-dialog v-model="isShowInfo" :footer="false" :easyToClose="true">
      <div class="info-dialog">
        <div class="title">{{useTitle}}使用说明</div>
        <div class="description" v-html="detail" />
      </div>
    </nd-dialog>
  </main>
</template>
<script>
export default {
  name: 'quan-item',
  props: {
    index: Number,
    useTitle: {
      type: String,
      default: ''
    },
    activeType: {
      type: String,
      default: ''
    },
    couponType: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    },
    money: {
      type: [String, Number],
      default: ''
    },
    unit: {
      type: String,
      default: ''
    },
    useType: {
      type: String,
      default: ''
    },
    detail: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    fontColor: {
      type: String,
      default: ''
    },
    isSelected: Boolean,
    showSelect: Boolean,
    showInfoBool: Boolean,
    isClick: Boolean
  }, 
  data () {
    return {
      isShowInfo: false
    }
  },
  methods: {
    // 选择
    changeSelected () {
      this.$emit('changeSelected', this.index)
    },
    // 展示info
    showInfo () {
      this.isShowInfo = true
    },
    // 跳转详情
    goDetail () {
      if (this.isClick) {
        this.$emit('goDetail')
      }
    }
  }
}
    
</script>
<style lang='less' scoped>
@import "../../assets/less/mixin.less";

main{
  // height: 180px;
  padding:0 30px 0;
  margin-top:20px;
  display: flex;
  align-items:center;
  justify-content: center;
  .item-bottom{
    display:flex;
    justify-content:space-between;
    align-items:center;
  } 
  .select{
    width: 36px;
    height:36px;
    margin-right:14px;
  }
  .red{
    color:red !important;
  }
  .black{
    padding-left:5px;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
  }
  .content{
    width: 670px;
    // height: 180px;
    background: #FFFFFF;
    box-shadow: 5px 10px 20px 0px #EEEEEE;
    border-radius: 20px;
    padding:66px 30px 15px 33px;
    position:relative;
    .activeType{
      position:absolute;
      top:0;
      left:0;
      height: 40px;
      line-height: 40px;
      background: linear-gradient(90deg, #FD7A16 0%, #FFB35C 100%);
      border-radius: 20px 0px 20px 0px;
      text-align:center;
      padding:0 12px;
      >span{
        width: 111px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        display: block;
      }
    }
    .data{
      display:flex;
      justify-content:space-between;
      height:61px;
      align-items:center;
     
      &-type{
        // width:173px;
        display:flex;
        justify-content:space-between;
        align-items:center;
        &-value{
          height: 48px;
          font-size: 34px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 48px;
        }
        &-img{
          margin-left: 8px;
          width:24px;
          height: 24px;
        }
      }
      &-money{
        height: 61px;
        font-size: 50px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        color: #333333;
        line-height: 61px;
      }
      &-unit {
        font-size: 28px;
        font-family: PingFangSC-Medium,PingFang SC;
        font-weight: 500;
        line-height: 40px;
        vertical-align: baseline;
      }
    }
    .endTime{
      margin-top:15px;
      height: 28px;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 28px;
    }
  }
  .info-dialog {
    padding: 10px 48px 60px;
    font-family: PingFangSC-Regular,PingFang SC;
    .title {
      text-align:center;
      font-size: 42px;
      height: 72px;
      line-height: 72px;
      font-family: PingFangSC-Semibold,PingFang SC;
      font-weight: 600;
    }
    .description {
      font-size: 30px;
      line-height: 32px;
      margin-top: 22px;
      font-weight: 400;
    }
  }
}
</style>